// @flow

import styled from 'styled-components';

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-items: center;
`;

export default Content;
